var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"edfe43cc2e85a94c7f2c19744009d76af5abccfc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["campanhas-frontend@ipco-j6"]={id:"edfe43cc2e85a94c7f2c19744009d76af5abccfc"};
      